import { DemurrageTerms } from './constants';

export const getDemurrageTermLabel = (
	demurrageTerm?: DemurrageTerms | string | null,
): string => (
	demurrageTerm === DemurrageTerms.DETENTION ?
		DemurrageTerms.DETENTION :
		DemurrageTerms.DEMURRAGE
);
